













































import { Component, Prop } from 'vue-property-decorator';
import Vue from 'vue';
import { Entry } from '@entries/interfaces/entry';
import VueBarcode from 'vue-barcode';
import QrcodeVue from 'qrcode.vue';

@Component({
  name: 'bpc-entry-barcode-page',
  components: {
    barcode: VueBarcode,
    QrcodeVue,
  },
})
export default class EntryBarcodePage extends Vue {
  @Prop({ type: String }) readonly token: string;
  loading = true;
  showErrorMessage = false;
  errorMessage = '';
  entry: Entry = null;
  formatBarCode = 'UPC';
  mounted() {
    this.getEntry();
  }

  async getEntry() {
    this.loading = true;
    this.showErrorMessage = false;
    const url = `${this.$bpcApiRouteHelper.getEntityPath('entries', 'raw')}/${this.token}`;
    try {
      const res = await this.$bpcApi.get(url).toPromise();
      this.entry = res.data;
    } catch (e) {
      this.errorMessage = 'entries.entry_not_found'; // TODO find warning message
      this.showErrorMessage = true;
    }
    this.loading = false;
  }

  getQr(): string {
    return `${this.entry.access_control_badge.badge_number}`;
  }

  isQR(): boolean {
    return this.entry.entry_category.badge_type === 'qr';
  }

  isBarcode(): boolean {
    return !this.isQR();
  }

  getBarcodeFormat(): string {
    const type = this.entry.entry_category.badge_type;
    return type === 'upc_barcode' ? 'UPC' : 'CODE128';
  }

  /* Lifecycle hooks */
  // created() {}
  // mounted() {}
  // updated() {}
  // destroyed() {}
}
